import { noop } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDisplayTimezone } from 'domains/timezone/useDisplayTimezone';
import { RadioCardGroup } from 'components/Forms';

type Props = {
  timeSlots: Date[];
  value?: Date;
  onChange: (value: Date) => void;
  labelKey?: string;
};

export const TimeSlotPicker: React.FC<Props> = ({ timeSlots, value, onChange, labelKey }) => {
  const { format } = useDisplayTimezone();
  const { t } = useTranslation();

  const timeSlotOptions = useMemo(
    () =>
      timeSlots?.map(d => ({
        label: format(d, 'h:mm a'),
        value: d.toISOString(),
      })) ?? [],
    [timeSlots, format],
  );

  return (
    <RadioCardGroup
      label={t(labelKey ?? 'consultation.schedule.availableSlots')}
      className="gap-14 grid-cols-5 sm-d:grid-cols-3 mb-64 sm-d:mb-40"
      disabled={false}
      options={timeSlotOptions}
      value={value?.toISOString()}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(new Date(e.target.value))}
      data-testid="time-slot-picker"
      name="select-time-slot"
      clearValue={noop}
      setError={noop}
      setValue={noop}
      labelClassName="font-semibold"
    />
  );
};
